<template>
  <div class="container w-3/4 sm:w-2/3 lg:w-full xl:w-2/3 flex flex-wrap justify-center py-20">
    <header class="h2 text-secondary">
      Blogs van {{ name }}
    </header>

    <div class="w-full grid gap-4 grid-cols-1 lg:grid-cols-3 py-8">
      <blog-item v-for="blog in blogs" :key="blog.slug" :blog="blog" :author="name"/>
    </div>

    <nuxt-link class="btn btn-secondary" to="/blogs">
      Lees alle blogs
    </nuxt-link>
  </div>
</template>

<script>
import BlogItem from '~/components/blog/BlogItem';

export default {
  components: {BlogItem},
  props: {
    name: {
      type: String,
      default: '',
    },
    blogs: {
      type: Array,
      default: () => ([]),
    },
  },
};
</script>
